export default {
  projectIcon: 'mdi-asterisk-circle-outline',
  systemIcon: 'mdi-chart-donut-variant',
  subsystemIcon: 'mdi-view-carousel',
  componentIcon: 'mdi-widgets',
  productIcon: 'mdi-chart-scatter-plot-hexbin',
  attributeIcon: 'mdi-tune-variant',
  detailIcon: 'mdi-dots-hexagon',
  dark: true,
  // App.vue main toast
  toast: {
    show: false,
    color: 'black',
    message: '',
    timeout: 3000
  },
  //#region Authentication
  useAuthentication: true,
  showLoginDialog: false,
  showCreateAccountDialog: false,
  showForgotPasswordDialog: false,
  authenticating: false,
  isGuest: false,
  isUser: false,
  user: {
    email: '',
    isGuest: false,
    isUser: false,
    id: 0,
    guid: ''
  }
  //#endregion
};
